import { z } from 'zod';

/**
 * Mirrors AdminAccountService.IsStrongEnough: at least 10 characters with a
 * letter and a digit. The backend re-checks it (WEAK_PASSWORD).
 */
export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'Enter your current password.'),
    newPassword: z
      .string()
      .min(10, 'Use at least 10 characters.')
      .max(100, 'Keep it under 100 characters.')
      .regex(/[A-Za-z]/, 'Include at least one letter.')
      .regex(/\d/, 'Include at least one digit.'),
    confirmPassword: z.string(),
  })
  .refine((values) => values.newPassword === values.confirmPassword, {
    path: ['confirmPassword'],
    message: 'The passwords do not match.',
  })
  .refine((values) => values.newPassword !== values.currentPassword, {
    path: ['newPassword'],
    message: 'Choose a password different from the current one.',
  });

export type ChangePasswordFormValues = z.infer<typeof changePasswordSchema>;
